import {
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import Button from "../UI/Button";
import { criarCantinaCreditoSolicitacaoTransacaoCartaoCredito } from "./CantinaCreditoSolicitacao/api-cantina-credito-solicitacao";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import { PatternFormat } from "react-number-format";
import MasterCardImg from "../../shared/assets/img/financeiro/cartao_credito/master-card.png";
import VisaCardImg from "../../shared/assets/img/financeiro/cartao_credito/visa.png";
import HipercardImg from "../../shared/assets/img/financeiro/cartao_credito/hipercard.png";
import { currencyRound } from "../../util/DoubleUtil";
import { useSelector } from "react-redux";
import { successBg, successBorder } from "../UI/ColorUtil";

const InsereCreditoCartaoCreditoForm = () => {
  const cincoKey = "cinco";
  const [checkBoxValorSelecionado, setCheckBoxValorSelecionaro] =
    useState(cincoKey);
  const quarentaKey = "quarenta";
  const sessentaKey = "sessenta";
  const descritoValorKey = "descrito-valor";
  const [cantinaCreditoSolicitacao, setCantinaCreditoSolicitacao] = useState({
    valorCredito: 5,
  });
  const [isLoadingAction, setIsLoadingAction] = useState(false);
  const [message, setMessage] = useState(null);
  const usuario = useSelector((state) => state.usuario);

  const handleOnSubmit = (event) => {
    event.preventDefault();
    if (cantinaCreditoSolicitacao.valorCredito) {
      if (cantinaCreditoSolicitacao.valorCredito < 5) {
        errorMessage("Valor tem que ser maior ou igual a R$ 5,00");
        return;
      } else if (cantinaCreditoSolicitacao.valorCredito > 500) {
        errorMessage("Valor tem que ser menor ou igual a R$ 500,00");
        return;
      }
    } else {
      errorMessage("Valor Inválido");
      return;
    }

    setIsLoadingAction(true);
    criarCantinaCreditoSolicitacaoTransacaoCartaoCredito(
      cantinaCreditoSolicitacao
    ).then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setCantinaCreditoSolicitacao(data);
          setMessage(
            "Foi incluído crédito de R$ " +
              currencyRound(data.valorCredito) +
              " na Cantina para o(a) aluno(a) " +
              usuario?.arAlunoSelecionado?.nome +
              ". O processo para entrar o Crédito no Sistema da Cantina pode demorar até 30 minutos."
          );
        }
      }
      setIsLoadingAction(false);
    });
  };

  const handleChangeCheckBoxValorCredito = (event) => {
    const nameTarget = event.target.name;
    if (nameTarget === cincoKey) {
      setCantinaCreditoSolicitacao((prevState) => ({
        ...prevState,
        valorCredito: 5,
      }));
    } else if (nameTarget === quarentaKey) {
      setCantinaCreditoSolicitacao((prevState) => ({
        ...prevState,
        valorCredito: 40,
      }));
    } else if (nameTarget === sessentaKey) {
      setCantinaCreditoSolicitacao((prevState) => ({
        ...prevState,
        valorCredito: 60,
      }));
    }
    setCheckBoxValorSelecionaro(nameTarget);
  };

  const handleChangeTextFieldValorCredito = (event) => {
    setCantinaCreditoSolicitacao({
      ...cantinaCreditoSolicitacao,
      valorCredito: +event.target.value,
    });
  };

  const handleChange = (event) => {
    setCantinaCreditoSolicitacao({
      ...cantinaCreditoSolicitacao,
      cartaoCreditoTransacao: {
        ...cantinaCreditoSolicitacao.cartaoCreditoTransacao,
        [event.target.name]: event.target.value,
      },
    });
  };

  const handleInserirNovoCredito = () => {
    setCantinaCreditoSolicitacao({ valorCredito: 5 });
    setMessage(null);
  };

  return (
    <Container sx={{ paddingTop: 2, paddingBottom: 2 }} component={Paper}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <Typography variant="h6">Cartão de Crédito</Typography>
        </Grid>
        {message ? (
          <>
            <Grid size={12}>
              <Typography
                style={{
                  backgroundColor: successBg,
                  borderRadius: "20px",
                  borderStyle: "solid",
                  borderColor: successBorder,
                  borderWidth: "5px",
                  margin: "10px",
                  padding: "10px",
                }}
                variant="body1"
              >
                {message}
              </Typography>
            </Grid>
            <Grid size={12}>
              <Button onClick={handleInserirNovoCredito}>
                Inserir novo Crédito
              </Button>
            </Grid>
          </>
        ) : (
          <>
            <Grid size={12}>
              <Typography variant="body1">
                Selecione ou Digite o valor para o Crédito:
              </Typography>
            </Grid>
            <Grid size={12}>
              <form onSubmit={handleOnSubmit}>
                <Grid container spacing={1}>
                  <Grid size={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkBoxValorSelecionado === cincoKey}
                          onChange={handleChangeCheckBoxValorCredito}
                          name={cincoKey}
                        />
                      }
                      label="R$ 5,00"
                    />
                  </Grid>
                  <Grid size={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkBoxValorSelecionado === quarentaKey}
                          onChange={handleChangeCheckBoxValorCredito}
                          name={quarentaKey}
                        />
                      }
                      label="R$ 40,00"
                    />
                  </Grid>
                  <Grid size={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkBoxValorSelecionado === sessentaKey}
                          onChange={handleChangeCheckBoxValorCredito}
                          name={sessentaKey}
                        />
                      }
                      label="R$ 60,00"
                    />
                  </Grid>
                  <Grid size={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            checkBoxValorSelecionado === descritoValorKey
                          }
                          onChange={handleChangeCheckBoxValorCredito}
                          name={descritoValorKey}
                        />
                      }
                      label="Digite o Valor do Crédito"
                    />
                  </Grid>
                  {checkBoxValorSelecionado === descritoValorKey && (
                    <Grid size={12}>
                      <Grid
                        container
                        direction="row"
                        spacing={3}
                        alignItems="center"
                      >
                        <Grid size={3}>
                          <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            type="number"
                            label="Valor Crédito"
                            name="valorCredito"
                            onChange={handleChangeTextFieldValorCredito}
                            value={
                              cantinaCreditoSolicitacao &&
                              cantinaCreditoSolicitacao.valorCredito
                                ? cantinaCreditoSolicitacao.valorCredito
                                : ""
                            }
                          />
                        </Grid>
                        <Grid size={3}>
                          <Typography variant="body1">
                            Serão aceitos valores entre R$ 5,00 e R$ 500,00.
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <Grid container direction="row">
                        <Grid size={6}></Grid>
                        <Grid>
                          <img
                            style={{
                              height: "30px",
                              width: "30px",
                            }}
                            src={MasterCardImg}
                            alt=""
                          />
                          <img
                            style={{
                              height: "25px",
                              width: "30px",
                              marginLeft: "10px",
                            }}
                            src={VisaCardImg}
                            alt=""
                          />
                          <img
                            style={{
                              height: "25px",
                              width: "30px",
                              marginLeft: "10px",
                            }}
                            src={HipercardImg}
                            alt=""
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid size={12}>
                      <Grid container direction="row">
                        <Grid size={6}>
                          <Typography variant="body1">Nome Impresso</Typography>
                        </Grid>
                        <Grid size={6}>
                          <TextField
                            name="nomeImpresso"
                            placeholder="Nome Impresso"
                            required
                            autoFocus
                            onChange={handleChange}
                            value={
                              cantinaCreditoSolicitacao.cartaoCreditoTransacao &&
                              cantinaCreditoSolicitacao.cartaoCreditoTransacao
                                .nomeImpresso
                                ? cantinaCreditoSolicitacao
                                    .cartaoCreditoTransacao.nomeImpresso
                                : ""
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid size={12}>
                      <Grid container direction="row">
                        <Grid size={6}>
                          <Typography variant="body1">Número Cartão</Typography>
                        </Grid>
                        <Grid size={6}>
                          <PatternFormat
                            format="#### #### #### ####"
                            allowEmptyFormatting
                            mask="_"
                            placeholder="XXXX XXXX XXXX XXXX"
                            onChange={handleChange}
                            value={
                              cantinaCreditoSolicitacao.cartaoCreditoTransacao &&
                              cantinaCreditoSolicitacao.cartaoCreditoTransacao
                                .numeroCartao
                                ? cantinaCreditoSolicitacao
                                    .cartaoCreditoTransacao.numeroCartao
                                : ""
                            }
                            name="numeroCartao"
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid size={12}>
                      <Grid container direction="row">
                        <Grid size={6}>
                          <Typography variant="body1">
                            Data Validade (MM/YYYY)
                          </Typography>
                        </Grid>
                        <Grid size={6}>
                          <PatternFormat
                            format="##/####"
                            allowEmptyFormatting
                            mask="_"
                            placeholder="XX/XXXX"
                            onChange={handleChange}
                            value={
                              cantinaCreditoSolicitacao.cartaoCreditoTransacao &&
                              cantinaCreditoSolicitacao.cartaoCreditoTransacao
                                .dataValidade
                                ? cantinaCreditoSolicitacao
                                    .cartaoCreditoTransacao.dataValidade
                                : ""
                            }
                            name="dataValidade"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid size={12}>
                      <Grid container direction="row">
                        <Grid size={6}>
                          <Typography variant="body1">
                            Código de Segurança
                          </Typography>
                        </Grid>
                        <Grid size={6}>
                          <PatternFormat
                            format="###"
                            allowEmptyFormatting
                            mask="_"
                            placeholder="XXX"
                            onChange={handleChange}
                            value={
                              cantinaCreditoSolicitacao.cartaoCreditoTransacao &&
                              cantinaCreditoSolicitacao.cartaoCreditoTransacao
                                .codigoSeguranca
                                ? cantinaCreditoSolicitacao
                                    .cartaoCreditoTransacao.codigoSeguranca
                                : ""
                            }
                            name="codigoSeguranca"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid size={12}>
                      <Grid container direction="row">
                        <Grid size={6}>
                          <Typography variant="body1">Valor</Typography>
                        </Grid>
                        <Grid size={6}>
                          <Typography variant="body1">
                            {cantinaCreditoSolicitacao.valorCredito
                              ? "R$ " +
                                currencyRound(
                                  cantinaCreditoSolicitacao.valorCredito
                                )
                              : ""}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid style={{ marginTop: "30px" }} size={12}>
                      <Grid container direction="row">
                        <Grid size={6}>
                          <Button disabled={isLoadingAction} type="submit">
                            {isLoadingAction && (
                              <CircularProgress
                                color="primary"
                                size={20}
                                style={{ marginRight: "10px" }}
                              />
                            )}
                            Realizar Pagamento
                          </Button>
                        </Grid>
                        <Grid size={6}></Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
};

export default InsereCreditoCartaoCreditoForm;
